import React from "react";
import { Col, Form, InputNumber } from "antd";

export const InputToolItem = ({ label, value, onChange, min = 0 }) => (
    <Col span={24}>
        <Form.Item
            label={label}
            labelCol={{ span: 12 }}
            wrapperCol={{ span: 12 }}
        >
            <InputNumber min={min} value={value} onChange={onChange} />
        </Form.Item>
    </Col>
);